import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Clock } from "lucide-react";
import { Button } from "./ui/button";

const CATEGORIES = [
  { value: "", label: "Anything" },
  { value: "restaurant", label: "Restaurants" },
  { value: "bar", label: "Bars" },
  { value: "cafe", label: "Cafés" },
  { value: "activity", label: "Activities" },
  { value: "nightlife", label: "Nightlife" },
];

export default function SearchBar() {
  const navigate = useNavigate();
  const [cat, setCat] = useState("");
  const [openNow, setOpenNow] = useState(false);

  const doSearch = () => {
    const params = new URLSearchParams();
    if (cat) params.set("category", cat);
    if (openNow) params.set("open_now", "1");
    const target = cat ? `/directory/${cat}` : "/directory/all";
    navigate(`${target}?${params.toString()}`);
  };

  return (
    <div className="w-full max-w-4xl mx-auto" data-testid="search-bar">
      <div className="bg-white rounded-2xl shadow-2xl p-2 flex flex-col md:flex-row items-stretch gap-1">
        <div className="flex-1 px-4 py-3 border-b md:border-b-0 md:border-r border-black/5">
          <label className="text-[11px] uppercase tracking-wider text-neutral-400 font-medium">What</label>
          <select
            value={cat}
            onChange={(e) => setCat(e.target.value)}
            className="block w-full bg-transparent outline-none font-heading text-base text-navy"
            data-testid="search-category"
          >
            {CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
          </select>
        </div>
        <div className="flex items-center px-4 py-3">
          <label className="text-[11px] uppercase tracking-wider text-neutral-400 font-medium flex items-center gap-1 mr-3">
            <Clock className="w-3 h-3" /> Open now
          </label>
          <button
            type="button"
            onClick={() => setOpenNow((s) => !s)}
            className={`relative w-10 h-5 rounded-full transition-colors ${openNow ? "bg-navy" : "bg-neutral-200"}`}
            data-testid="search-open-now"
          >
            <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-transform ${openNow ? "translate-x-5" : "translate-x-0.5"}`} />
          </button>
        </div>
        <Button
          onClick={doSearch}
          className="h-auto rounded-xl md:rounded-xl bg-navy hover:bg-navy/90 text-white px-6 m-1 min-h-12"
          data-testid="search-submit-button"
        >
          <Search className="w-4 h-4 mr-2" /> Search
        </Button>
      </div>
    </div>
  );
}
